import { ContentItemDtoType, IConcertSeriesDto, ContentItemDto } from '../../clients/services';
import { Paragraph } from './Paragraph';
import parse from 'html-react-parser';

const getParagraphs = (series: IConcertSeriesDto, includeTicketReservationLink: boolean) => {
    const paragraps = [];

    const addDefaultPicture = !series.content?.paragraphs?.some((p) => p.type === ContentItemDtoType.DefaultPicture);
    const addConcertInfo = !series.content?.paragraphs?.some((p) => p.type === ContentItemDtoType.ConcertInfo);
    const addReservationLink =
        includeTicketReservationLink &&
        !series.content?.paragraphs?.some((p) => p.type === ContentItemDtoType.TicketReservationLink);

    if (addDefaultPicture) {
        paragraps.push(new ContentItemDto({ type: ContentItemDtoType.DefaultPicture }));
        if (addConcertInfo) {
            paragraps.push(new ContentItemDto({ type: ContentItemDtoType.ConcertInfo }));
            if (addReservationLink) {
                paragraps.push(new ContentItemDto({ type: ContentItemDtoType.TicketReservationLink }));
            }
        }
    }

    for (const p of series?.content?.paragraphs ?? []) {
        paragraps.push(p);
        if (p.type === ContentItemDtoType.DefaultPicture) {
            if (addConcertInfo) {
                paragraps.push(new ContentItemDto({ type: ContentItemDtoType.ConcertInfo }));
                if (addReservationLink) {
                    paragraps.push(new ContentItemDto({ type: ContentItemDtoType.TicketReservationLink }));
                }
            }
        } else if (p.type === ContentItemDtoType.ConcertInfo) {
            if (addReservationLink) {
                paragraps.push(new ContentItemDto({ type: ContentItemDtoType.TicketReservationLink }));
            }
        }
    }

    return paragraps;
};

interface ConcertPreviewProps extends IConcertSeriesDto {
    includeTicketReservationLink?: boolean;
}

export const ConcertPreview = ({ includeTicketReservationLink = true, ...series }: ConcertPreviewProps) => {
    const paragraphs = getParagraphs(series, includeTicketReservationLink);

    return (
        <div className="konzert">
            <div>
                <h2>{parse(series.title)}</h2>
                {series.content?.introduction && <h3>{parse(series.content.introduction)}</h3>}
                {paragraphs?.map((p, k) => (
                    <Paragraph key={k} p={p} series={series} />
                ))}
                <hr />
            </div>
        </div>
    );
};

export default ConcertPreview;
